<div class="tab-pane" uib-tab-content-transclude="tab">
  <app-dealer-profile [profile]="profile"></app-dealer-profile>
  <span style="font-weight: 700" class="ng-scope">Comments</span>
  <div class="table-responsive">
    <table *ngIf="profile.comments.length > 0; else noComments" class="table mftable table-bordered"
           appDatatableKeyboard [mfData]="profile.comments" #mf="mfDataTable" [mfRowsOnPage]="numberOfDisplayedRows">
      <thead class="thead-dark">
        <tr>
          <th style="width: 20%" [ngClass]="{'active': activeColumn === 1}">
            <mfDefaultSorter (click)="activeColumn = 1" by="dateAdded">Date <i class="fa fa-sort" aria-hidden="true"></i></mfDefaultSorter>
          </th>
          <th style="width: 20%" [ngClass]="{'active': activeColumn === 2}">
            <mfDefaultSorter (click)="activeColumn = 2" by="creatorName">User <i class="fa fa-sort" aria-hidden="true"></i></mfDefaultSorter>
          </th>
          <th style="width: 60%"><span class="no-sortable">Comment</span></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let comment of mf.data">
          <td class="ng-binding">{{comment.dateAdded | date:'medium'}}</td>
          <td class="ng-binding">{{comment.creatorName}}</td>
          <td class="ng-binding remarks">{{comment.comments}}</td>
        </tr>
      </tbody>
      <tfoot *ngIf="!isTablePaginationHidden">
      <tr>
        <td colspan="100%" class="pagination-container">
          <mfBootstrapPaginator [rowsOnPageSet]="[10,25,50,100]"></mfBootstrapPaginator>
        </td>
      </tr>
      </tfoot>
    </table>
  </div>
  <form [formGroup]="commentForm" (ngSubmit)="addComment()" *appHasAuthority="'MANAGE_PROFILE'">
    <div class="form-group">
      <label for="comment">Add a Comment</label>
      <textarea id="comment" formControlName="comment" class="form-control required" aria-required="true"
                [ngClass]="{'is-invalid': hasError('comment')}"
                aria-label="comment" required></textarea>
      <div *ngIf="hasError('comment')" role="alert" class="formError text-danger" aria-live="assertive">
        <div *ngIf="hasError('comment', 'required')">Required</div>
        <div *ngIf="hasError('comment', 'maxlength')">Comment is too long</div>
      </div>
    </div>
    <button type="submit" [disabled]="!commentForm.valid"
            class="btn btn-primary btn-sm"><i class="far fa-comments"></i> Add Comment</button>
  </form>
</div>

<ng-template #noComments>
  <p>There are no comments for this dealer currently.</p>
</ng-template>
